import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import ApproveModal from '../../../../app/common/modals/ApproveModal';
import { v4 as uuid } from 'uuid';
import { useStore } from '../../../../app/stores/store';
import DynamicTableComponent from '../../../DynamicTable/DynamicTableComponent';
import _ from 'lodash';
import { InwardTableDynamictableData } from '../../DashboardContainer/DynamictableCondition';

interface Props {
  name: string;
}

function InwardsTable({ name }: Props) {
  const {
    activityStore: {
      inwardFetchTableDetails,
      inward,
      inwardFetchSortTableDetails,
    },
    dashboardStore: { dashboard },
    commonStore,
  } = useStore();

  const [pageNumber, setPageNumber] = useState<number>(1);
  const [localName, setLocalName] = useState<string>('');
  const [filterTwoData, setFilterTwoData] = useState<any[]>([]);
  const [actionType, setActionType] = useState<string>('');

  useEffect(() => {
    setLocalName(name?.replaceAll(' ', ''));
    if (!!name?.length) {
      inwardFetchTableDetails('', 1, name.replaceAll(' ', ''));
    }
    setPageNumber(1);

    // eslint-disable-next-line
  }, [name]);
  useEffect(() => {
    const ids: any = InwardTableDynamictableData.filter(
      (element: any) => name === element.name,
    );
    setFilterTwoData(ids);
  }, [name]);

  const caseHandler = () => {
    let tableDetails: any[] = [];
    switch (localName) {
      case 'Verify':
        tableDetails = inward.verify.data;
        break;
      case 'Approve':
        tableDetails = inward.approve.data;
        break;
      case 'MoveToVault':
        tableDetails = inward.moveToVault.data;
        break;
      case 'PickerAssign':
        tableDetails = inward.PickerAssign.data;
        break;
      default:
        tableDetails = [];
    }
    return tableDetails;
  };

  const paginateFunction = (e: number) => {
    let searchValues = dashboard.searchfilterparams;
    let value = Object.keys(searchValues)?.length ? searchValues : '';
    if (
      !_.isEmpty(searchValues) &&
      Object.values(searchValues).every((o) => o !== '') &&
      dashboard.orderData === '' &&
      dashboard.orderName === ''
    ) {
      inwardFetchTableDetails(value, e, localName);
    } else if (dashboard.orderData !== '' && dashboard.orderName !== '') {
      inwardFetchSortTableDetails(
        dashboard.orderData,
        localName,
        dashboard.orderName || '',
        e || 1,
        (inward as any)[`${_.camelCase(localName)}`].count || 0,
      );
    } else {
      inwardFetchTableDetails(value, e, localName);
    }
    setPageNumber(e);
  };
  useEffect(() => {
    const L2 = dashboard.L2CardValueOrders;
    const L3 = dashboard.valueForL3Orders;
    const tempActionType =
      L2 === 'Inward' && L3 === 'Verify'
        ? 'Verify|Deny'
        : L2 === 'Inward' && L3 === 'Approve'
          ? 'Approve|Deny'
          : L2 === 'Inward' && L3 === 'Move To Vault'
            ? 'Movement Complete'
            : '';
    setActionType(tempActionType);
  }, [dashboard.L2CardValueOrders, dashboard.valueForL3Orders]);

  return (
    <>
      {dashboard.DenialModal ? (
        <ApproveModal />
      ) : dashboard.reportsConfiguration ? (
        <></>
      ) : null}
      {commonStore.filterModeTwo.includes(filterTwoData[0]?.id) ? (
        <></>
      ) : (
        !!localName?.length && (
          <DynamicTableComponent
            key={uuid()}
            data={caseHandler()}
            name={localName}
            actiontype={actionType}
            pageFunc={paginateFunction}
            pageNumData={pageNumber}
            setPageNumber={setPageNumber}
            searchFuncData={() => {}}
            isdisabled={commonStore.filterModeZero.includes(
              filterTwoData?.[0]?.id,
            )}
          />
        )
      )}
    </>
  );
}

export default observer(InwardsTable);
